import { Link } from "react-router-dom";
import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

const services = [
  {
    icon: "ri-layout-4-line",
    title: "Web Design",
    tagline: "For small businesses",
    desc: "Custom, mobile-friendly websites built to rank on Google and turn visitors into paying customers.",
    link: "/services#web-design",
    bg: "bg-zinc-100",
    dark: false,
  },
  {
    icon: "ri-refresh-line",
    title: "Website Redesign",
    tagline: "For outdated sites",
    desc: "Transform your old, clunky website into a modern, high-converting digital presence your business deserves.",
    link: "/services#redesign",
    bg: "bg-accent",
    dark: true,
  },
  {
    icon: "ri-search-2-line",
    title: "SEO for Small Businesses",
    tagline: "Get found on Google",
    desc: "Local SEO strategies that get your business showing up when your customers are searching for you.",
    link: "/services#seo",
    bg: "bg-emerald-50",
    dark: false,
  },
];

export default function ServicesPreview() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="section-pad bg-white" ref={ref}>
      <div className="container-md">
        <div
          className={`text-center mb-12 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <span className="text-accent text-xs font-semibold uppercase tracking-[0.2em] mb-4 block">
            What we do
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-zinc-900 leading-tight">
            Services built for
            <br className="hidden md:block" /> small business growth
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <Link
              key={s.title}
              to={s.link}
              className={`group rounded-2xl p-8 flex flex-col cursor-pointer transition-all duration-300 hover:-translate-y-1 border ${
                s.dark
                  ? "border-transparent"
                  : "border-zinc-200 hover:border-accent/30"
              } ${s.bg} ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <span
                className={`inline-block text-xs font-semibold px-3 py-1 rounded-full mb-5 w-fit ${
                  s.dark
                    ? "bg-white/20 text-white"
                    : s.bg === "bg-emerald-50"
                    ? "bg-emerald-100 text-emerald-700"
                    : "bg-accent/15 text-accent"
                }`}
              >
                {s.tagline}
              </span>
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <i
                  className={`${s.icon} text-3xl ${
                    s.dark
                      ? "text-white"
                      : s.bg === "bg-emerald-50"
                      ? "text-emerald-600"
                      : "text-accent"
                  }`}
                />
              </div>
              <h3
                className={`font-heading text-2xl font-bold mb-3 ${
                  s.dark ? "text-white" : "text-zinc-900"
                }`}
              >
                {s.title}
              </h3>
              <p
                className={`text-sm leading-relaxed flex-1 ${
                  s.dark ? "text-white/70" : "text-zinc-500"
                }`}
              >
                {s.desc}
              </p>
              <div
                className={`flex items-center gap-2 mt-6 text-sm font-medium transition-colors ${
                  s.dark
                    ? "text-white/80 group-hover:text-white"
                    : "text-zinc-500 group-hover:text-accent"
                }`}
              >
                <span>Learn more</span>
                <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
